"use client"

import * as React from "react"
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import { CircleIcon } from "lucide-react"

import { cn } from "@/lib/utils"

function RadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn("grid gap-3", className)}
      {...props}
    />
  )
}

function RadioGroupItem({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        // Base: 16×16px circle, neutral.10 border, white bg
        "aspect-square size-4 shrink-0 rounded-full border border-[var(--field-text-color)] bg-[var(--field-bg)] text-[var(--field-text-color)] outline-none transition-[box-shadow,border-color] duration-200",
        // Checked: white bg + neutral.10 border (dot shown via indicator)
        "data-[state=checked]:border-[var(--field-text-color)] data-[state=checked]:bg-[var(--field-bg)]",
        // Hover + focus: 1px gap (field-bg) then brown ring — reads clearly off the neutral border
        "hover:shadow-[0_0_0_1px_var(--field-bg),0_0_0_3px_var(--field-focus-color)] focus-visible:shadow-[0_0_0_1px_var(--field-bg),0_0_0_3px_var(--field-focus-color)]",
        // Error: red.40 border, no focus halo
        "aria-invalid:border-[var(--field-error-color)] aria-invalid:shadow-none",
        // Disabled: 0.6 opacity
        "disabled:cursor-not-allowed disabled:opacity-[0.6]",
        className
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="relative flex items-center justify-center"
      >
        <CircleIcon className="fill-[var(--field-text-color)] absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
}

export { RadioGroup, RadioGroupItem }
